export const FETCH_PRODUCT_DATA = "FETCH_PRODUCT_DATA";
export const FETCH_PRODUCT_DATA_SUCCESS = "FETCH_PRODUCT_DATA_SUCCESS";
export const FETCH_PRODUCT_DATA_FAILED = "FETCH_PRODUCT_DATA_FAILED";
export const FETCH_PRODUCT_DATES = "FETCH_PRODUCT_DATES";
export const FETCH_PRODUCT_DATES_SUCCESS = "FETCH_PRODUCT_DATES_SUCCESS";
export const FETCH_PRODUCT_DATES_FAILED = "FETCH_PRODUCT_DATES_FAILED";
export const FETCH_SENDLIST_DATA = "FETCH_SENDLIST_DATA";
export const FETCH_SENDLIST_DATA_SUCCESS = "FETCH_SENDLIST_DATA_SUCCESS";
export const FETCH_SENDLIST_DATA_FAILED = "FETCH_SENDLIST_DATA_FAILED";
